import { Mail } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LangContext";
import { mailTechSupport } from "@/lib/analysisMail";

export const TechContactButton = ({ data, s, i }) => {
  const { tr } = useLang();
  const high = s.impact === "high";
  const click = () => { mailTechSupport(data, s); toast.success(tr("Richiesta preparata — controlla la tua email.", "Request prepared — check your email.")); };
  return (
    <button type="button" data-testid={`tech-contact-btn-${i}`} onClick={click}
      className={`mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-medium rounded-full transition-[transform,opacity] hover:-translate-y-0.5 hover:opacity-90 ${high ? "bg-[#E0262C] text-white" : "bg-[#f59e0b] text-[#09090b]"}`}>
      <Mail className="w-3.5 h-3.5" /> {tr("Parla gratis con un tecnico", "Talk to a technician for free")}
    </button>
  );
};
